// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"style_tabContent__2FJQ4"};